module.exports = __webpack_public_path__ + "static/media/icici.043d2755.svg";